import { useRef, useMemo } from 'preact/hooks';
import dayjs from 'dayjs';
import { calculateAvailabilityWindow } from '../utils';

const useAvailabilityWindow = (currentMonth, maxDate) => {
  const loadedWindowsRef = useRef([]);
  const maxDateKey = dayjs(maxDate).isValid() ? dayjs(maxDate).format('YYYY-MM-DD') : null;

  const availabilityWindow = useMemo(() => {
    if (!currentMonth) return null;

    const now = new Date();
    const isCurrentMonth =
      currentMonth.getFullYear() === now.getFullYear() &&
      currentMonth.getMonth() === now.getMonth();
    const windowAnchor = isCurrentMonth ? now : currentMonth;

    const newWindow = calculateAvailabilityWindow(windowAnchor, maxDate);
    const existing = loadedWindowsRef.current.find(
      window => window.from === newWindow.from && window.to === newWindow.to,
    );
    if (existing) return existing;

    loadedWindowsRef.current = [...loadedWindowsRef.current, newWindow];
    return newWindow;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMonth?.getFullYear(), currentMonth?.getMonth(), maxDateKey]);

  const resetWindows = () => {
    loadedWindowsRef.current = [];
  };

  return { availabilityWindow, resetWindows };
};

export default useAvailabilityWindow;
